import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const ChevronsLeft = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 21.929688 13.371094 C 22.542969 12.871094 23.449219 12.90625 24.019531 13.480469 C 24.59375 14.050781 24.628906 14.957031 24.128906 15.570312 L 24.019531 15.6875 L 14.710938 25 L 24.019531 34.3125 L 24.128906 34.429688 C 24.628906 35.042969 24.59375 35.949219 24.019531 36.523438 C 23.449219 37.09375 22.542969 37.128906 21.929688 36.628906 L 21.8125 36.523438 L 11.394531 26.105469 C 10.785156 25.496094 10.785156 24.503906 11.394531 23.894531 L 21.8125 13.480469 Z M 36.511719 13.371094 C 37.125 12.871094 38.03125 12.90625 38.605469 13.480469 C 39.175781 14.050781 39.214844 14.957031 38.710938 15.570312 L 38.605469 15.6875 L 29.292969 25 L 38.605469 34.3125 L 38.710938 34.429688 C 39.214844 35.042969 39.175781 35.949219 38.605469 36.523438 C 38.03125 37.09375 37.125 37.128906 36.511719 36.628906 L 36.394531 36.523438 L 25.980469 26.105469 C 25.367188 25.496094 25.367188 24.503906 25.980469 23.894531 L 36.394531 13.480469 Z M 36.511719 13.371094 "
        fill={color}
      />
    </svg>
  )
}
